var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('Navbar',{attrs:{"selected":_vm.selected,"selecteData":_vm.selecteData},on:{"update:selected":function($event){_vm.selected=$event},"update:selecteData":function($event){_vm.selecteData=$event},"update:selecte-data":function($event){_vm.selecteData=$event}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }